import type { DefenseProfileData, Ruleset } from "./Ruleset";

export class DefenseProfile {
  ruleset: Ruleset;
  data: DefenseProfileData;

  constructor(ruleset: Ruleset, data: DefenseProfileData) {
    this.ruleset = ruleset;
    this.data = data;
  }

  get id() {
    return this.data.id;
  }

  get name() {
    return this.data.name;
  }
}
